// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__226aZ","colBig":"styles_colBig__2nlYH","colSmall":"styles_colSmall__279AZ","shopifyNameWrapper":"styles_shopifyNameWrapper__1nOSD"};